import { render, staticRenderFns } from "./AddEventDialog.vue?vue&type=template&id=09c569b9&scoped=true&"
import script from "@/components/mi-calendar/AddEventDialog.ts?vue&type=script&lang=ts&"
export * from "@/components/mi-calendar/AddEventDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/components/mi-calendar/add-event-dialog.scss?vue&type=style&index=0&id=09c569b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c569b9",
  null
  
)

export default component.exports